import React from 'react';

import { DatePicker } from '@components/common';
import { withDefaultOptions } from '@components/common/DatePicker/HOC';

const DatePickerWithOption = withDefaultOptions(DatePicker);
// eslint-disable-next-line react/display-name
export default React.forwardRef((props, ref) => <DatePickerWithOption innerRef={ref} {...props} />);
